import { render } from "./AppointmentDetailDialog.vue?vue&type=template&id=46770cc1"
import script from "./AppointmentDetailDialog.vue?vue&type=script&lang=js"
export * from "./AppointmentDetailDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__